import React from 'react';
import { F, linkedIds } from '../utils.jsx';
import { TABLE_IDS, CURRENT_USER } from '../globals.js';
import { ResponsiblePicker } from './team/TeamView.jsx';

export default function AccountIntelTab({
  accStakeholders, stakeholderEngagement, opps,
  intelNotes, editingNotes, notesValue, setNotesValue, setEditingNotes, saveIntelNotes, savingNotes,
  isAdmin, users, account, api, onLogActivity, onUpdateRecord, centralBase = false,
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>

      {/* Red Flags */}
      <div className="card" style={{ borderLeft: '3px solid #B4362C' }}>
        <div className="card-header"><h3>Señales de alerta</h3></div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {(() => {
            const flags = [];
            if (accStakeholders.length === 0)
              flags.push('No hay contactos cargados: ¿quién es la persona de contacto?');
            if (accStakeholders.length > 0 && !stakeholderEngagement.some(e => e.hasReplied))
              flags.push('Todavía no respondió ningún contacto');
            const staleCount = stakeholderEngagement.filter(e => e.daysSince !== null && e.daysSince > 21).length;
            if (staleCount > 0)
              flags.push(`${staleCount} ${staleCount === 1 ? 'contacto' : 'contactos'} sin interacción hace más de 21 días`);
            if (opps.length === 0)
              flags.push('No hay oportunidades abiertas: ¿la necesidad está confirmada?');
            const allClear = flags.length === 0;
            if (allClear)
              flags.push('Sin alertas: la empresa se ve activa.');
            return flags.map((f, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, padding: '8px 0', borderBottom: i < flags.length - 1 ? '1px solid rgba(30,42,44,0.05)' : 'none' }}>
                <span style={{ fontSize: 14, flexShrink: 0 }}>{allClear ? '✅' : '⚠️'}</span>
                <span style={{ fontSize: 12, color: allClear ? '#1E7B4F' : 'var(--globant-text)', lineHeight: 1.5 }}>{f}</span>
              </div>
            ));
          })()}
        </div>
      </div>

      {/* Notes */}
      <div style={{ border: '1px solid rgba(91,191,181,0.18)', borderRadius: 12, padding: '14px 18px', background: 'rgba(91,191,181,0.04)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: editingNotes || intelNotes ? 10 : 0 }}>
          <span style={{ fontSize: 11, fontWeight: 800, color: 'var(--globant-green)', letterSpacing: '1px', textTransform: 'uppercase' }}>Tus notas</span>
          <div style={{ display: 'flex', gap: 6 }}>
            {!editingNotes ? (
              <button className="action-btn btn-ghost" style={{ fontSize: 11 }} onClick={() => { setNotesValue(intelNotes); setEditingNotes(true); }}>
                {intelNotes ? 'Editar' : 'Agregar'}
              </button>
            ) : (
              <>
                <button className="action-btn btn-ghost" style={{ fontSize: 11 }} onClick={() => setEditingNotes(false)}>Cancelar</button>
                <button className="action-btn btn-primary" style={{ fontSize: 11 }} onClick={saveIntelNotes} disabled={savingNotes}>
                  {savingNotes ? 'Guardando…' : 'Guardar'}
                </button>
              </>
            )}
          </div>
        </div>
        {editingNotes ? (
          <textarea className="input-field" value={notesValue} onChange={e => setNotesValue(e.target.value)}
            placeholder="Lo que sabés de esta empresa: reuniones, contactos clave, decisiones, contexto interno…"
            style={{ width: '100%', minHeight: 100, fontSize: 12, lineHeight: 1.6, resize: 'vertical', marginTop: 4 }} />
        ) : intelNotes ? (
          <div style={{ fontSize: 12, color: 'var(--globant-text)', lineHeight: 1.6, whiteSpace: 'pre-wrap', maxHeight: 300, overflowY: 'auto' }}>{intelNotes}</div>
        ) : (
          <div style={{ fontSize: 12, color: 'var(--globant-muted)', fontStyle: 'italic' }}>
            Note what you know: meetings, context, internal signals, relevant conversations.
          </div>
        )}
      </div>

      {/* Team Assignment — admin only */}
      {isAdmin && (() => {
        const bdrs = users.filter(u => {
          const r = F(u, 'Role');
          const role = typeof r === 'object' ? r?.name : r;
          return (role || '').toLowerCase() === 'bdr';
        });
        const cps = users.filter(u => {
          const r = F(u, 'Role');
          const role = typeof r === 'object' ? r?.name : r;
          return (role || '').toLowerCase() === 'cp';
        });
        const currentBdrIds = linkedIds(account, 'BDR');
        const currentCpIds = linkedIds(account, 'CP');
        const currentBdr = currentBdrIds[0] || '';
        const currentCp = currentCpIds[0] || '';

        const assignUser = async (field, userId) => {
          if (!api) return;
          try {
            const val = userId ? [userId] : [];
            await api.updateRecord(TABLE_IDS.accounts, account.id, { [field]: val });
            if (onUpdateRecord) onUpdateRecord('accounts', account.id, { [field]: val });
            if (onLogActivity) onLogActivity();
          } catch (e) { window.__oikeToast('No se pudo asignar: ' + e.message, 'error'); }
        };

        const sStyle = { width: '100%', padding: '7px 10px', background: 'var(--globant-input)', border: '1px solid var(--globant-border)', borderRadius: 6, color: 'var(--globant-text)', fontSize: 12, boxSizing: 'border-box' };
        const lStyle = { fontSize: 10, fontWeight: 700, color: 'var(--globant-muted)', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 5, display: 'block' };

        return (
          <div className="card" style={{ borderLeft: '3px solid #6B5CA5' }}>
            <div className="card-header"><h3>Equipo asignado</h3></div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <div>
                <label style={lStyle}>BDR asignado</label>
                {/* Oike's central base: the responsible changes only with its history (team.mts › assign) */}
                {centralBase ? <ResponsiblePicker account={account} users={users} onUpdateRecord={onUpdateRecord} compact /> : (
                  <select style={sStyle} value={currentBdr} onChange={e => assignUser('BDR', e.target.value)}>
                    <option value="">— Unassigned —</option>
                    {bdrs.map(u => <option key={u.id} value={u.id}>{F(u, 'Name') || F(u, 'Email') || u.id}</option>)}
                  </select>
                )}
              </div>
              <div>
                <label style={lStyle}>Client Partner asignado</label>
                <select style={sStyle} value={currentCp} onChange={e => assignUser('CP', e.target.value)}>
                  <option value="">— Unassigned —</option>
                  {cps.map(u => <option key={u.id} value={u.id}>{F(u, 'Name') || F(u, 'Email') || u.id}</option>)}
                </select>
              </div>
            </div>
          </div>
        );
      })()}

    </div>
  );
}
